import {setACNT, sortFunc, iAmHigherAuthority, compareRole} from "../../libs.jsx";
import {isNumber} from "chart.js/helpers";
import {useNotifications} from "../../contexts/NotificationContext.jsx";
import { getSession } from "../../services/session";

const CampusDropDown = (props) => {
    let dData, selectOptions = [], sortedData = [];
    const { resubscribeToCurrentCampus } = useNotifications();

    if (getSession() != null){
        dData = getSession();
    }

    if (dData?.acntList){
        for (let i=0; i<dData.acntList.length; i++){
            sortedData.push({CampusName: dData?.campusData[dData.acntList[i]]?.name, CampusId: dData.acntList[i], Valid: dData?.campusData[dData.acntList[i]]?.valid})
        }
        sortedData.sort((a, b) => sortFunc(a, b, "CampusName", "asc"))
    }
    if (!compareRole("admin", dData) || iAmHigherAuthority(99, dData?.role_weight)){
        if (dData?.acntList){
            for (let i=0; i<sortedData.length; i++){
                if (sortedData[i]?.Valid){
                    selectOptions.push(
                        <option key={`${sortedData[i]?.CampusId}-option-${i}`} value={sortedData[i]?.CampusId}>{sortedData[i]?.CampusName}</option>
                    )
                }else{
                    selectOptions.push(
                        <option disabled={true} key={`${sortedData[i]?.CampusId}-option-${i}`} value={sortedData[i]?.CampusId}>{sortedData[i]?.CampusName} <p style={{color: "var(--color-danger)"}}>(Expired)</p></option>
                    )
                }
            }
        }else{
            selectOptions.push(
                <option disabled={true} key={dData.acnt+"-option"} value={dData.acnt}>{dData?.campus}</option>
            )
        }
        return (
            <div className={"form-floating mx-3"} style={{minWidth: "200px"}}>
                <select className={"form-select"} required={true} id={"campusDash"} value={props?.campusId}
                        onChange={(e) => {
                            if (isNumber(e.target.value)){
                                setACNT(dData, parseInt(e.target.value));
                                props?.setCampusId(parseInt(e.target.value));
                            }else{
                                setACNT(dData, e.target.value);
                                props?.setCampusId(e.target.value);
                            }
                            props?.setCount(0);
                            props?.pageAction(e);
                            // Resubscribe to AppSync for the new campus
                            if (resubscribeToCurrentCampus) {
                                resubscribeToCurrentCampus();
                            }
                        }}>
                    {selectOptions}
                </select>
                <label htmlFor={"campusDash"}>Campus</label>
            </div>
        )
    }else{
        return "";
    }
}

export default CampusDropDown;